/** @format */

import {
    REGULATORY_INDUSTRY_NOTAPPLICABLE,
    FORM_FACTOR_ROLLS,
    REGULATORY_INDUSTRY_TYPES,
    GRAPHIC_DESIGN_ORDER_TYPE_ARTWORK_EDITS,
    GRAPHIC_DESIGN_ORDER_TYPE_ARTWORK_RECREATION,
    GRAPHIC_DESIGN_ORDER_TYPE_CUSTOM_DESIGN,
    MAXIMUM_ROLL_DIAMETER,
    PRODUCT_TYPE_CARTON,
    PRODUCT_TYPE_GRAPHIC_DESIGN,
    PRODUCT_TYPE_LABEL,
    ROLL_SIZE_TYPE_DIAMETER,
    ROLL_SIZE_TYPE_QTY,
    SHAPE_CARTON_CUSTOM,
    SIZE_TYPE_CUSTOM_NEW,
    SIZE_TYPE_STANDARD_NEW,
    SUBSTRATE_WHITE_VINYL
} from 'frontier-constants';
import {AccountContext} from 'frontier-utilities';
import {useContext} from 'react';
import DimensionValidator from 'frontier/utilities/dimension_validator';
import {getMaxRollDiameterForWidth, isNarrowLabel} from 'frontier/utilities/roll_min_max_validator';
import {calcDiameterFromQty, calcQtyFromDiameter} from 'frontier-utilities';

const addError = (errors, errorItem) => {
    errors.push({
        category: errorItem?.category,
        subcategory: errorItem?.subcategory,
        blocking: typeof errorItem.blocking === 'undefined' ? true : errorItem.blocking,
        message: errorItem?.message
    });
};

export function validateOrderWithErrors(order) {
    let errors = [];
    const {order_uploads} = order;
    let logoUploads = null,
        styleReferenceUploads = null;
    try {
        if (order.product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN) {
            // Setup variables for different upload types
            if (typeof order_uploads !== 'undefined') {
                logoUploads = order_uploads.filter(upload => upload.type === 'logo').length;
                styleReferenceUploads = order_uploads.filter(
                    upload => upload.type === 'style_reference'
                ).length;
            }

            if (!order.substrate_id) {
                addError(errors, {category: 'substrate', message: 'Select a Material'});
            }
            if (
                order.graphic_design_order_details.design_type_id ===
                GRAPHIC_DESIGN_ORDER_TYPE_ARTWORK_RECREATION ||
                order.graphic_design_order_details.design_type_id ===
                GRAPHIC_DESIGN_ORDER_TYPE_ARTWORK_EDITS
            ) {
                if (order.design_qty < 1) {
                    addError(errors, {
                        category: 'total_qty',
                        message: 'Upload Artwork'
                    });
                }

                if (
                    !order.graphic_design_order_details?.comments_graphic_design ||
                    order.graphic_design_order_details?.comments_graphic_design.length < 1
                ) {
                    addError(errors, {
                        category: 'comments',
                        message: 'Please Provide Artwork Instructions'
                    });
                }

                const sizeErrors = validateSize(order);
                errors = [...errors, ...sizeErrors];
            } else if (
                order.graphic_design_order_details.design_type_id ===
                GRAPHIC_DESIGN_ORDER_TYPE_CUSTOM_DESIGN
            ) {
                const sizeErrors = validateSize(order);
                errors = [...errors, ...sizeErrors];

                if (order.form_factor_id === FORM_FACTOR_ROLLS && !order.roll_direction_id) {
                    addError(errors, {
                        category: 'form_factor',
                        message: 'Select a roll direction'
                    });
                }

                if (order.graphic_design_order_details.design_product_type_id === PRODUCT_TYPE_LABEL) {
                    if (order.shape_id === 0) {
                        addError(errors, {category: 'form_factor', message: 'Select A Shape'});
                    }
                    if (!(order.width > 0) || !(order.length > 0)) {
                        addError(errors, {category: 'size', message: 'Enter label dimensions'});
                    }
                } else if (order.graphic_design_order_details.design_product_type_id === PRODUCT_TYPE_CARTON){
                    if (!(order.width > 0) || !(order.length > 0) || !(order.depth > 0)) {
                        addError(errors, {category: 'size', message: 'Enter carton dimensions'});
                    }
                }

                if (order.graphic_design_order_details.is_vector_logo && !logoUploads) {
                    addError(errors, {
                        category: 'design_style_vector',
                        message: 'Upload Logo Vector Files'
                    });
                }

                if (!order.graphic_design_order_details.product_industry_id) {
                    addError(errors, {category: 'industry', message: 'Select Your Industry'});
                }

                if(!(REGULATORY_INDUSTRY_TYPES.find(
                    i => i.id == order.graphic_design_order_details.product_industry_id
                )?.id === REGULATORY_INDUSTRY_NOTAPPLICABLE || order.graphic_design_order_details.product_regulatory_information?.length > 1)) {
                    addError(errors, {category: 'industry', message: 'Enter Industry Regulatory Info'});
                }

                if (
                    (!(order.graphic_design_order_details.design_style_preferences?.length > 0)) &&
                    !styleReferenceUploads
                ) {
                    addError(errors, {
                        category: 'design_style',
                        message: 'Select Your Design Style Preference'
                    });
                }

                if (!order.graphic_design_order_details.brand_description) {
                    addError(errors, {
                        category: 'brand',
                        message: 'Enter Your Brand Description'
                    });
                }

                if (!order.graphic_design_order_details.website_url) {
                    addError(errors, {
                        category: 'brand',
                        message: 'Enter Your Website'
                    });
                }

                if (!order.graphic_design_order_details.product_name_description) {
                    addError(errors, {
                        category: 'product',
                        message: 'Enter Your Product Name &  Description'
                    });
                }

                if(!order.graphic_design_order_details.product_ingredients_directions){
                    addError(errors, {
                        category: 'brand',
                        message: 'Enter Your Product Ingredients & Directions for Use'
                    })
                }

                if(!order.graphic_design_order_details.product_ingredients_directions){
                    addError(errors, {
                        category: 'brand',
                        message: 'Ingredients & Directions'
                    })
                }

                if(!order.graphic_design_order_details.specific_fonts){
                    addError(errors, {
                        category: 'brand',
                        message: 'Preferred Fonts'
                    })
                }

                if(!order.graphic_design_order_details.look_feel_description){
                    addError(errors, {
                        category: 'brand',
                        message: 'Describe Look & Feel'
                    })
                }

                if (
                    (!order.graphic_design_order_details.color_preference_specific &&
                        !order.graphic_design_order_details.color_preferences) ||
                    (Array.isArray(order.graphic_design_order_details.color_preferences) &&
                        order.graphic_design_order_details.color_preferences.length < 1 &&
                        !order.graphic_design_order_details.color_preference_specific)
                ) {
                    addError(errors, {
                        category: 'color',
                        message: 'Select Your Color Preferences'
                    });
                }

            }
            if (
                order.graphic_design_order_details.design_type_id ===
                GRAPHIC_DESIGN_ORDER_TYPE_ARTWORK_RECREATION
            ) {
                if (!logoUploads) {
                    addError(errors, {
                        category: 'total_qty',
                        message: 'Upload Logo Files'
                    });
                }
            }
        } else {
            const sizeErrors = validateSize(order);
            errors = [...errors, ...sizeErrors];

            // MATERIAL & LAMINATE
            if (!order.substrate_id || !order.laminate_id) {
                errors.splice(0, 0, {
                    category: 'substrate_and_laminate',
                    message: 'Select Material & Laminate'
                });
            }

            // Substrate Size Mismatch
            if (
                parseInt(order.substrate_id) === SUBSTRATE_WHITE_VINYL &&
                order.width > 0 &&
                order.length > 0 &&
                (order.width < 1 || order.length < 1)
            ) {
                addError(errors, {
                    category: order.width < 1 ? 'width' : 'length',
                    message: 'White Vinyl must be at least 1"'
                });
            }

            // FORMAT
            if (!order.form_factor_id && order.product_type_id === PRODUCT_TYPE_LABEL) {
                addError(errors, {category: 'form_factor', message: 'Select Application'});
            }

            // ARTWORK
            if (order.design_qty < 1) {
                addError(errors, {
                    category: 'total_qty',
                    message: 'Upload Artwork (Now or Later)'
                });
            }
            if (order.order_uploads?.length < 1 && order.total_qty < 1) {
                addError(errors, {
                    category: 'total_qty',
                    message:
                        order.product_type_id === PRODUCT_TYPE_LABEL
                            ? 'Provide Label & Design Quantity'
                            : 'Provide Carton & Design Quantity'
                });
            } else if (order.design_qty > 0 && order.total_qty < 1) {
                addError(errors, {
                    category: 'total_qty',
                    message: 'Enter Total Quantity'
                });
            }
            if (order.design_qty > 0 && order.designs_orders.length === order.design_qty) {
                let designTotalQty = 0;
                let hasEmptyQty = false;
                order.designs_orders.map(designOrder => {
                    if (!designOrder.qty) {
                        hasEmptyQty = true;
                    }
                    designTotalQty += designOrder.qty;
                });

                if (hasEmptyQty || !designTotalQty) {
                    addError(errors, {
                        category: 'total_qty',
                        subcategory: 'design_qty',
                        message: 'Enter a Quantity for all designs'
                    });
                }
            }

            // MACHINE DIRECTION
            if (order.form_factor_id === FORM_FACTOR_ROLLS && !order.roll_direction_id) {
                addError(errors, {
                    category: 'form_factor',
                    message: 'Select a roll direction'
                });
            }

            // VARIABLE DATA
            if (
                order.is_variable_data &&
                !(
                    order.variable_data_special_requests ||
                    order_uploads.find(file => file.type === 'variable_data')
                )
            ) {
                addError(errors, {
                    category: 'variable_data',
                    message: 'Variable Data is chosen, but no file provided.'
                });
            }

            if (order.is_duplex || order.is_front_back) {
                if (order.designs_orders.length % 2 !== 0) {
                    const printType = order.is_duplex ? 'duplex' : 'front/back';
                    addError(errors, {
                        category: 'duplex',
                        message: `You must upload an even number of files for ${printType} printing.`
                    });
                }
            }

            // MIN-MAX DATA
            if (order.is_special_roll_qty) {
                // If company level roll requirements are set
                let accountRollOptionsEnabled = false;
                let accountRollDiameterMax = '';
                let accountRollQtyMax = '';
                let accountIsFewestPossibleRolls = false;
                if (window?.cartPreload) {
                    if (
                        cartPreload?.user?.company_entity?.roll_max ||
                        cartPreload?.user?.company_entity?.is_fewest_possible_rolls
                    ) {
                        accountRollOptionsEnabled = true;

                        // Apply width-based constraints to company settings
                        const maxAllowedDiameter = getMaxRollDiameterForWidth(order.width, order.product_type_id);
                        let companyRollMax = cartPreload.user.company_entity.roll_max;

                        if (cartPreload.user.company_entity.roll_type_id === ROLL_SIZE_TYPE_DIAMETER) {
                            // Constrain diameter if it exceeds width-based limit
                            accountRollDiameterMax = companyRollMax > maxAllowedDiameter ? maxAllowedDiameter : companyRollMax;
                            accountRollQtyMax = '';
                        } else {
                            // Constrain quantity if resulting diameter exceeds width-based limit
                            if (companyRollMax && order.length && order.substrate_id) {
                                const resultingDiameter = calcDiameterFromQty({
                                    qty: companyRollMax,
                                    length: order.length,
                                    substrateId: order.substrate_id,
                                    isHighOpacityWhite: order.is_high_opacity_white
                                });

                                if (resultingDiameter > maxAllowedDiameter) {
                                    accountRollQtyMax = calcQtyFromDiameter({
                                        diameter: maxAllowedDiameter,
                                        length: order.length,
                                        substrateId: order.substrate_id,
                                        isHighOpacityWhite: order.is_high_opacity_white
                                    });
                                } else {
                                    accountRollQtyMax = companyRollMax;
                                }
                            } else {
                                accountRollQtyMax = companyRollMax;
                            }
                            accountRollDiameterMax = '';
                        }

                        accountIsFewestPossibleRolls =
                            cartPreload.user.company_entity.is_fewest_possible_rolls;
                    }
                } else {
                    const accountCtx = useContext(AccountContext);
                    if (accountCtx?.user?.company_entity) {
                        let companySettings = accountCtx.user.company_entity;
                        if (
                            companySettings?.roll_max ||
                            companySettings?.is_fewest_possible_rolls
                        ) {
                            accountRollOptionsEnabled = true;

                            // Apply width-based constraints to company settings
                            const maxAllowedDiameter = getMaxRollDiameterForWidth(order.width, order.product_type_id);
                            let companyRollMax = companySettings.roll_max;

                            if (companySettings.roll_type_id === ROLL_SIZE_TYPE_DIAMETER) {
                                // Constrain diameter if it exceeds width-based limit
                                accountRollDiameterMax = companyRollMax > maxAllowedDiameter ? maxAllowedDiameter : companyRollMax;
                                accountRollQtyMax = '';
                            } else {
                                // Constrain quantity if resulting diameter exceeds width-based limit
                                if (companyRollMax && order.length && order.substrate_id) {
                                    const resultingDiameter = calcDiameterFromQty({
                                        qty: companyRollMax,
                                        length: order.length,
                                        substrateId: order.substrate_id,
                                        isHighOpacityWhite: order.is_high_opacity_white
                                    });

                                    if (resultingDiameter > maxAllowedDiameter) {
                                        accountRollQtyMax = calcQtyFromDiameter({
                                            diameter: maxAllowedDiameter,
                                            length: order.length,
                                            substrateId: order.substrate_id,
                                            isHighOpacityWhite: order.is_high_opacity_white
                                        });
                                    } else {
                                        accountRollQtyMax = companyRollMax;
                                    }
                                } else {
                                    accountRollQtyMax = companyRollMax;
                                }
                                accountRollDiameterMax = '';
                            }

                            accountIsFewestPossibleRolls = companySettings.is_fewest_possible_rolls;
                        }
                    }
                }

                if (order.is_account_roll_defaults_applied) {
                    // Skip account preset validation for narrow labels since they have automatic restrictions
                    const isNarrowLabelOrder = isNarrowLabel(order.width, order.product_type_id);

                    if (accountRollOptionsEnabled && !isNarrowLabelOrder) {
                        if (order.is_fewest_possible_rolls !== accountIsFewestPossibleRolls) {
                            addError(errors, {
                                category: 'max_rolls',
                                blocking: false,
                                message:
                                    'The Fewest Possible Rolls size preset does not match your Account Presets. You can RESET or proceed as is.'
                            });
                        }
                        if (order.roll_diameter_max !== accountRollDiameterMax) {
                            addError(errors, {
                                category: 'max_diameter',
                                blocking: false,
                                message:
                                    'The Max Diameter roll size preset does not match your Account Presets. You can RESET or proceed as is.'
                            });
                        }
                        if (order.roll_qty_max !== accountRollQtyMax) {
                            addError(errors, {
                                category: 'max_qty',
                                blocking: false,
                                message:
                                    'The Max Qty roll size preset does not match your Account Presets. You can RESET or proceed as is.'
                            });
                        }
                    }
                    if (!order.roll_max && !order.is_fewest_possible_rolls) {
                        addError(errors, {
                            category: 'max_qty',
                            blocking: false,
                            message: 'Please enter a value.'
                        });
                    }
                    if (order.roll_diameter_max) {
                        const maxAllowedDiameter = getMaxRollDiameterForWidth(order.width, order.product_type_id);
                        if (order.roll_diameter_max > maxAllowedDiameter) {
                            const isNarrowLabelOrder = isNarrowLabel(order.width, order.product_type_id);
                            const isNarrowLabelRestriction = maxAllowedDiameter < MAXIMUM_ROLL_DIAMETER;

                            // Don't show narrow label error in account section since system will auto-apply restrictions
                            if (!isNarrowLabelOrder || !isNarrowLabelRestriction) {
                                addError(errors, {
                                    category: 'max_diameter',
                                    blocking: true, // Make this blocking to prevent add to cart
                                    message: isNarrowLabelRestriction
                                        ? 'Labels under 7/8" wide are limited to 8" diameter rolls for optimal production quality.'
                                        : 'Your Maximum Roll Diameter cannot be higher than ' +
                                          MAXIMUM_ROLL_DIAMETER +
                                          '".'
                                });
                            }
                        }
                    } else if (!order.roll_diameter_max && !order.roll_max) {
                        addError(errors, {
                            category: 'max_diameter',
                            blocking: false,
                            message: 'Please enter a value.'
                        });
                    }

                    // Validate roll quantity doesn't exceed diameter constraint
                    if (order.roll_qty_max && order.roll_qty_max > 0) {
                        const resultingDiameter = calcDiameterFromQty({
                            qty: order.roll_qty_max,
                            length: order.length,
                            substrateId: order.substrate_id,
                            isHighOpacityWhite: order.is_high_opacity_white
                        });

                        const maxAllowedDiameter = getMaxRollDiameterForWidth(order.width, order.product_type_id);

                        if (resultingDiameter > maxAllowedDiameter) {
                            const isNarrowLabelOrder = isNarrowLabel(order.width, order.product_type_id);
                            const isNarrowLabelRestriction = maxAllowedDiameter < MAXIMUM_ROLL_DIAMETER;

                            // Don't show narrow label error in account section since system will auto-apply restrictions
                            if (!isNarrowLabelOrder || !isNarrowLabelRestriction) {
                                addError(errors, {
                                    category: 'max_qty',
                                    blocking: true, // Make this blocking to prevent add to cart
                                    message: isNarrowLabelRestriction
                                        ? 'This quantity would result in a roll diameter larger than 8". Labels under 7/8" wide are limited to 8" diameter rolls for optimal production quality.'
                                        : `This quantity would result in a roll diameter larger than ${MAXIMUM_ROLL_DIAMETER}".`
                                });
                            }
                        }
                    }
                }
            }
        }
    } catch (e) {
        addError(errors, {category: 'exception', message: e.message});
    }

    return {
        isComplete: errors.filter(e => e.blocking).length === 0,
        errors
    };
}

function validateSize(order) {
    let errors = [];
    let productTypeId =
        order.product_type_id === PRODUCT_TYPE_GRAPHIC_DESIGN
            ? order.graphic_design_order_details.design_product_type_id
            : order.product_type_id;

    const dmv = new DimensionValidator({
        productTypeId: productTypeId,
        width: order.width,
        length: order.length,
        shapeId: order.shape_id,
        depth: order.depth
    });

    if (
        order.size_type_id === SIZE_TYPE_CUSTOM_NEW ||
        order.size_type_id === SIZE_TYPE_STANDARD_NEW
    ) {
        if (order.width > 0 && order.length > 0 && order.shape_id > 0) {
            if (order.size_type_id === SIZE_TYPE_STANDARD_NEW) {
                if (order.width > 0) {
                    if (dmv.isBelowMinWidth() && productTypeId !== PRODUCT_TYPE_CARTON) {
                        addError(errors, {
                            category: 'width',
                            message: dmv.belowMinWidthMessage()
                        });
                    }
                    if (dmv.isAboveMaxWidth() && productTypeId === PRODUCT_TYPE_LABEL) {
                        addError(errors, {
                            category: 'width',
                            message: dmv.aboveMaxWidthMessage()
                        });
                    }
                }
                if (dmv.isBelowMinLength()) {
                    addError(errors, {
                        category: 'length',
                        message: dmv.belowMinLengthMessage()
                    });
                }
                if (dmv.isAboveMaxLength() && productTypeId === PRODUCT_TYPE_LABEL) {
                    addError(errors, {
                        category: 'length',
                        message: dmv.aboveMaxLengthMessage()
                    });
                }
                if (productTypeId === PRODUCT_TYPE_LABEL) {
                    if (dmv.isNotSnapped(order.width)) {
                        addError(errors, {
                            category: 'width',
                            message: dmv.notSnappedMessage(order.width)
                        });
                    }
                    if (dmv.isNotSnapped(order.length)) {
                        addError(errors, {
                            category: 'length',
                            message: dmv.notSnappedMessage(order.length)
                        });
                    }
                }
                if (productTypeId === PRODUCT_TYPE_CARTON) {
                    if (dmv.isNotSnapped(order.width)) {
                        addError(errors, {
                            category: 'width',
                            message: dmv.notSnappedMessage(order.width)
                        });
                    }
                    if (dmv.isNotSnapped(order.length)) {
                        addError(errors, {
                            category: 'length',
                            message: dmv.notSnappedMessage(order.length)
                        });
                    }
                    if (dmv.isNotSnapped(order.depth)) {
                        addError(errors, {
                            category: 'depth',
                            message: dmv.notSnappedMessage(order.depth)
                        });
                    }
                }
            }
        } else if (productTypeId !== PRODUCT_TYPE_CARTON && order.graphic_design_order_details.design_type_id !==
            GRAPHIC_DESIGN_ORDER_TYPE_CUSTOM_DESIGN) {
            addError(errors, {
                category: 'size',
                message: 'Select Shape & Size'
            });
        }
    } else if (!order.size_id) {
        addError(errors, {category: 'size', message: 'Missing a die ID'});
    }

    // CARTON-SPECIFIC
    if (productTypeId === PRODUCT_TYPE_CARTON && order.shape_id !== SHAPE_CARTON_CUSTOM) {
        if (order.width > 0 && order.length > 0 && order.depth > 0) {
            if (dmv.isWidthGreaterThanLength()) {
                addError(errors, {
                    category: 'width',
                    message: dmv.widthGreaterThanLengthMessage()
                });
            }
            if (dmv.isBelowMinWidthCarton()) {
                addError(errors, {
                    category: 'carton_size',
                    message: dmv.belowMinWidthCartonMessage()
                });
            }
            if (dmv.isBelowMinWidthAndLength()) {
                addError(errors, {
                    category: 'carton_size',
                    message: dmv.belowMinWidthAndLengthMessage()
                });
            }
            if (dmv.isAboveMaxWidthAndLength()) {
                addError(errors, {
                    category: 'carton_size',
                    message: dmv.aboveMaxWidthAndLengthMessage()
                });
            }
            if (dmv.isBelowMinDepth()) {
                addError(errors, {
                    category: 'depth',
                    message: dmv.belowMinDepthMessage()
                });
            }
            if (dmv.isAboveMaxDepth()) {
                addError(errors, {
                    category: 'depth',
                    message: dmv.aboveMaxDepthMessage()
                });
            }
        } else {
            addError(errors, {category: 'size', message: 'Select Size'});
        }
    }

    return errors;
}
